// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3sjGv","img":"styles_img__3QIwu"};